module.exports = __webpack_public_path__ + "static/media/dot-menu.42bb4a66.svg";